// Custom next/image loader — bypasses Vercel's Image Optimization API
// entirely, routing resizing/format-conversion through wsrv.nl (free, no
// account) instead. Vercel Hobby caps transformations at 5K/month, shared
// with other projects on this account; exhausting it makes every <Image>
// 402 (OPTIMIZED_IMAGE_REQUEST_PAYMENT_REQUIRED).
//
// `src` is already absolute for Supabase-hosted images (matches
// next.config.ts's old remotePatterns entry); local /public assets arrive as
// a root-relative path, so they're resolved against the canonical prod
// origin — wsrv.nl fetches over the public internet, it can't see relative
// paths on this deployment. Same NEXT_PUBLIC_SITE_URL + fallback pattern
// already used inline across the app (e.g. src/app/layout.tsx, sitemap.ts).
const SITE_URL = (process.env.NEXT_PUBLIC_SITE_URL || 'https://www.siriuscoffee.com').trim();

export default function siriusImageLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}): string {
  const absoluteSrc = src.startsWith('http') ? src : `${SITE_URL}${src}`;
  const params = new URLSearchParams({
    url: absoluteSrc,
    w: String(width),
    q: String(quality ?? 75),
    output: 'webp',
  });
  return `https://wsrv.nl/?${params.toString()}`;
}
